<template>
    <div class="step-progress">
        <div v-for="(step, index) in steps"
             :key="step.id"
             :class="[step.id < currentStepId ? 'step-progress__step--past' : '',step.id == currentStepId ? 'step-progress__step--active' : ''  , 'step-progress__step']">

            <span class="step-progress__step-index">{{ step.id }}</span>
            <span class="step-progress__step-label">{{ step.label }}</span>

        </div>
    </div>
</template>

<script>
    import { mapState, mapGetters, mapMutations } from 'vuex';

    export default {
        mounted() {

            const stepTitles = [
                { id: 1, label: this.labels.stepOneStepTitle},
                { id: 2, label: this.labels.stepTwoStepTitle},
                { id: 3, label: this.labels.stepThreeStepTitle},
                { id: 4, label: this.labels.stepFourStepTitle},
                { id: 5, label: this.labels.stepFiveStepTitle},
            ]

            this.updateStepTitleLabels(stepTitles);
        },

        methods: {
            ...mapMutations("stepProgress", [
                "updateStepTitleLabels"
            ])
        },

        computed: {
            ...mapState('stepProgress', [
                'steps',
            ]),

            ...mapGetters('stepProgress', [
                'currentStepId'
            ]),

            ...mapState('microcopy', [
                'labels',
            ])
        }
    }
</script>